export const FETCH_SUCCESS = "SETTINGS_ACCOUNT_GROUPS/FETCH_SUCCESS";
export const TABLE_UPDATE = "SETTINGS_ACCOUNT_GROUPS/TABLE_UPDATE";

const types = {
    FETCH_SUCCESS,
    FETCH_FAILED: "SETTINGS_ACCOUNT_GROUPS/FETCH_FAILED",
    FETCH_REQUEST: "SETTINGS_ACCOUNT_GROUPS/FETCH_REQUEST",

    UPDATE_FAILED: "SETTINGS_ACCOUNT_GROUPS/UPDATE_FAILED",
    UPDATE_REQUEST: "SETTINGS_ACCOUNT_GROUPS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "SETTINGS_ACCOUNT_GROUPS/UPDATE_SUCCESS",

    CREATE_REQUEST: "SETTINGS_ACCOUNT_GROUPS/CREATE_REQUEST",
    CREATE_SUCCESS: "SETTINGS_ACCOUNT_GROUPS/CREATE_SUCCESS",
    CREATE_FAILED: "SETTINGS_ACCOUNT_GROUPS/CREATE_FAILED",

    DELETE_REQUEST: "SETTINGS_ACCOUNT_GROUPS/DELETE_REQUEST",
    DELETE_SUCCESS: "SETTINGS_ACCOUNT_GROUPS/DELETE_SUCCESS",
    DELETE_FAILED: "SETTINGS_ACCOUNT_GROUPS/DELETE_FAILED",

    GET_FAILED: "SETTINGS_ACCOUNT_GROUPS/GET_FAILED",
    GET_REQUEST: "SETTINGS_ACCOUNT_GROUPS/GET_REQUEST",
    GET_SUCCESS: "SETTINGS_ACCOUNT_GROUPS/GET_SUCCESS",

    TABLE_UPDATE,
};

export default types;
